import axios from 'axios';
import Notify from 'simple-notify';
import { v4 as uuidv4 } from 'uuid';

export function showNotification(type, title, msg) {
  new Notify({
    status: type,
    title: title,
    text: msg,
    effect: 'slide',
    position: 'center',
    autoclose: true,
    autotimeout: 15000,
    type: 3
  });
}

export function generateGUID() {
  return uuidv4();
}

// export function applicationDomain() {
//   if (window.location.href.includes('localhost') && window.location.href.includes('?')) {
//     return `${window.location.href.split('?')[0]}`;
//   }
//   else if (window.location.href.includes('localhost')) {
//     return `${window.location.href}`;
//   }
//   else {
//     let appDomainName = `${settings.app_domain}/${settings.app_name}`;
//     if (appDomainName.includes('?')) {
//       let url = appDomainName.split('?')[0].replace('index.html', '');
//       return url;
//     }
//     return `${appDomainName.replace('index.html', '')}`;
//   }
// }

export function applicationDomain() {
  if (window.location.href.includes('localhost') && window.location.href.includes('?')) {
    return `${window.location.origin.split('?')[0]}`;
  }
  else if (window.location.href.includes('localhost')) {
    return `${window.location.origin}`;
  }
  else {
    if (window.location.href.includes('?')) {
      let url = window.location.href.split('?')[0].replace('index.html', '');
      return url;
    }
    return `${window.location.href.replace('index.html', '')}`;
  }
}


export function getConfig(appDomain, configPath, domainOff = true) {
  let  URL = domainOff ? `${appDomain}/${configPath}`: configPath;
 // let URL = `${configPath}`;

  return fetch(URL, {
    mode: "cors"
  }).then(res => res.json())
    .then(data => {
      return data;
    })
    .catch(err => {
      console.log('can\'t read the config json file', err);
      return "-1";
    });
}


export async function readFile(filePath, domainOff) {
  return await getConfig(null,filePath, domainOff);
}